// components/Home/Home.jsx
import React from 'react';
import './Home.css';

const Home = () => {
  const handleCtaClick = () => {
    const target = document.querySelector('#contacto');
    if (target) {
      const headerOffset = 80;
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="home-section">
      <h1>DB ALAMBRADOS</h1>
      <p>Soluciones completas en cercos perimetrales para tu seguridad</p>
      <a href="#contacto" className="cta-button" onClick={(e) => { e.preventDefault(); handleCtaClick(); }}>
        Contactanos Ahora
      </a>
    </section>
  );
};

export default Home;